import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';
import React from 'react';

function AccreditingBodyRadio(props) {
    return (
        <Grid item key='accreditingBody' xs={12} component={props.component} {...props.animation}>
            <FormControl error={props.error}>
                <FormLabel id='accrediting'>Accrediting body</FormLabel>
                <RadioGroup
                    onChange={props.onChange}
                    aria-labelledby='accrediting'
                    name='accreditingBody'
                    value={props.value}
                >
                    <FormControlLabel
                        value='RCPSC'
                        control={<Radio />}
                        label='The Royal College of Physicians and Surgeons of Canada (RCPSC)'
                    />
                    <FormControlLabel
                        value='CFPC'
                        control={<Radio />}
                        label='The College of Family Physicians of Canada (CFPC)'
                    />
                    <FormControlLabel value='Other' control={<Radio />} label='Other' />
                </RadioGroup>
            </FormControl>
        </Grid>
    );
}

export default AccreditingBodyRadio;
